export const ENVIRONMENT_PREFIX = {
  dev: 'dev',
  test: 'tst',
  production: '',
} as const
